import React, { useState } from 'react';
import styles from './TermsDialog.module.css';

/**
 * Enhanced Terms of Service dialog component
 * - Combines TOS and age verification in one screen
 * - Styled to match platform design
 */
const TermsDialog = ({ 
  termsText, 
  onAccept, 
  onDecline,
  language = 'en'
}) => {
  const [isChecked, setIsChecked] = useState(false);
  
  // Get localized button text based on language
  const getLocalizedText = () => {
    const text = {
      buttons: {
        en: { accept: 'I Accept', decline: 'Decline' },
        es: { accept: 'Acepto', decline: 'Rechazar' },
        ja: { accept: '同意する', decline: '拒否する' },
        fr: { accept: 'J\'accepte', decline: 'Refuser' },
        it: { accept: 'Accetto', decline: 'Rifiuto' },
        de: { accept: 'Ich akzeptiere', decline: 'Ablehnen' },
        ro: { accept: 'Accept', decline: 'Refuz' },
        pt: { accept: 'Eu aceito', decline: 'Recusar' },
        ru: { accept: 'Я принимаю', decline: 'Отклонить' },
        ko: { accept: '동의합니다', decline: '거부합니다' },
        zh: { accept: '我接受', decline: '拒绝' },
        ar: { accept: 'أوافق', decline: 'رفض' },
        hi: { accept: 'मैं स्वीकार करता हूं', decline: 'अस्वीकार' }
      },
      age: {
        en: 'I confirm I am at least 13 years old or have parental permission to use this service.',
        es: 'Confirmo que tengo al menos 13 años o tengo permiso de mis padres para usar este servicio.',
        ja: '私は13歳以上であるか、このサービスを使用するための保護者の許可を持っていることを確認します。',
        fr: 'Je confirme avoir au moins 13 ans ou avoir la permission parentale pour utiliser ce service.',
        it: 'Confermo di avere almeno 13 anni o di avere il permesso dei genitori per utilizzare questo servizio.',
        de: 'Ich bestätige, dass ich mindestens 13 Jahre alt bin oder die Erlaubnis der Eltern habe, diesen Dienst zu nutzen.',
        ro: 'Confirm că am cel puțin 13 ani sau am permisiunea părinților pentru a utiliza acest serviciu.',
        pt: 'Confirmo que tenho pelo menos 13 anos ou tenho permissão dos pais para usar este serviço.',
        ru: 'Я подтверждаю, что мне не менее 13 лет или у меня есть разрешение родителей на использование этого сервиса.',
        ko: '저는 13세 이상이거나 이 서비스를 사용하기 위한 부모님의 허가가 있음을 확인합니다.',
        zh: '我确认我至少已13岁或者有父母的许可使用此服务。',
        ar: 'أؤكد أن عمري 13 عامًا على الأقل أو لدي إذن الوالدين لاستخدام هذه الخدمة.',
        hi: 'मैं पुष्टि करता हूं कि मैं कम से कम 13 वर्ष का हूं या इस सेवा का उपयोग करने के लिए मेरे पास माता-पिता की अनुमति है।'
      }
    };
    
    return {
      buttons: text.buttons[language] || text.buttons.en,
      ageConfirmation: text.age[language] || text.age.en
    };
  };
  
  const localizedText = getLocalizedText();
  
  return (
    <div className={styles.overlay}>
      <div className={styles.dialogContainer}>
        <div className={styles.dialogContent}>
          <h2 className={styles.title}>Terms of Service</h2>
          
          <div className={styles.termsText}>
            <div dangerouslySetInnerHTML={{ __html: termsText }} />
          </div>
          
          <div className={styles.checkboxContainer}>
            <label className={styles.checkboxLabel}>
              <input
                type="checkbox"
                checked={isChecked}
                onChange={() => setIsChecked(!isChecked)}
                className={styles.checkbox}
              />
              <span>{localizedText.ageConfirmation}</span>
            </label>
          </div>
          
          <div className={styles.buttonContainer}>
            <button 
              onClick={onDecline} 
              className={styles.buttonDecline}
            >
              {localizedText.buttons.decline}
            </button>
            <button 
              onClick={onAccept} 
              className={styles.buttonAccept}
              disabled={!isChecked}
            >
              {localizedText.buttons.accept}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsDialog;
